module.exports = __webpack_public_path__ + "media/images/flags/bd-cba8921056d6880ae2e5bcee90f1bc4e.svg";